import settings from '../../../src/es6/settings'
import $ from 'jquery'

$('.newsletter__form').on('change mouseup mouseout keyup', e => {
    $('.newsletter__email').val().match(settings.mail_regex)
    ? $('.newsletter__btn').removeClass('disabled')
    : $('.newsletter__btn').addClass('disabled')
})